(ns frontend.ui.component.rich-text-editor.core
  (:require
   ["draft-js" :refer [EditorState]]
   ["draft-js-import-html" :refer [stateFromHTML]]
   [reagent.core :as r]
   [clojure.string :as string]))

(defn init-state
  [html-content]
  (if (or (not html-content)
          (string/blank? (string/trim (str html-content))))
    (r/atom (.createEmpty EditorState))
    (r/atom (.createWithContent EditorState (stateFromHTML html-content)))))
